import i18n from 'i18next'
// @TODO: Enable whenever multi lingual required
// import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

import { formatDate } from '../util/date.helpers'
import { CURRENCIES } from '../util/staking/staking.helpers'
import { getSupportedLanguages } from '../util/translation.helpers'

const DETECTION_OPTIONS = {
  order: ['cookie', 'localStorage', 'navigator'],
  lookupCookie: 'locale',
  lookupLocalStorage: 'locale',
  caches: ['localStorage', 'cookie'],
  checkWhitelist: true
}

const supportedLanguages = getSupportedLanguages()

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'no-store'
      }
    },
    detection: DETECTION_OPTIONS,
    fallbackLng: supportedLanguages[0],
    ns: ['default', 'brand'],
    defaultNS: 'default',
    // supportedLngs: supportedLanguages,
    // whitelist: supportedLanguages, @TODO: deprecated use supportedLngs
    lng: supportedLanguages[0], // @TODO: Remove whenever multi lingual required
    supportedLngs: [supportedLanguages[0]],
    debug: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      format: formatDate,
      defaultVariables: {
        stakingSymbol: CURRENCIES.QBX
      }
    },
    react: {
      useSuspense: false
    }
  })

export default i18n
